import script from "./ForgotPasswordCompleteView.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPasswordCompleteView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__